export default __webpack_public_path__ + "assets/images/1763fb2ed8fd1416.svg";